import { render, staticRenderFns } from "./RelationOrders.vue?vue&type=template&id=11881c80&"
import script from "./RelationOrders.vue?vue&type=script&lang=tsx&"
export * from "./RelationOrders.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports